import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import app from './modules/app';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    user,
    app,
  },
});
